import { RepositoryFactory } from '../../api/RepositoryFactory';
const FormsCalls = RepositoryFactory.get('forms');
const GalleryCalls = RepositoryFactory.get('gallery');
import store from '../../store/store';
import Helper from './resources';
import i18n from '../../i18n/i18n';
import { printAsync } from '@/components/xdent-form/helpers.js';

import $ from 'jquery';
import 'select2';
import 'select2/select2.css';
import 'select2/select2_locale_cs.js';

let helpers = {
    replaceChar: (string, char, replace) => {
        const regex = new RegExp(char);
        return string.replace(regex, replace);
    },
    getPdf: (idForm, isIos) => {
        return new Promise((resolve, reject) => {
            if (isIos) {
                isIos = true;
            }
            FormsCalls.getPdf(idForm, isIos, JSON.parse(localStorage.getItem('token')))
                .then(({ data }) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    getSharedPdf: (idForm, isIos) => {
        return new Promise((res, rej) => {
            if (isIos) {
                isIos = true;
            }
            GalleryCalls.getFileContentById(idForm, isIos, JSON.parse(localStorage.getItem('token')))
                .then(({ data }) => {
                    res(data);
                })
                .catch((err) => rej(err));
        });
    },
    setMetaTitle(key) {
        // console.log(this.$route, key,i18n.t(key));
        document.title = i18n.t(key) ? i18n.t(key) + ' - iklient.cz' : 'iklient.cz'; // (i18n.t(key) || 'Přehled') + ' - iklient.cz';
    },
    async openPdf(form) {
        // adblock workaround https://stackoverflow.com/questions/43283454/open-blob-objecturl-in-chrome
        // let win = window.open('', '_blank');
        // let idFile = form.formType !== 'DOCUMENT' ? form.idForm : (form.idFileSigned || form.idFile);
        // let blob = await this.getPdf(idFile);
        // win.document.write('<div style="font-size: 40px;font-family: Tahoma, sans-serif;display: flex;align-items: center;height: 100%;justify-content: center;">Načítám…</div>');
        // // win.onload = () => {
        //     win.location = URL.createObjectURL(blob);
        // // };

        let idFile = form.formType !== 'DOCUMENT' ? form.idForm : form.idFileSigned || form.idFile;
        let route = this.$router.resolve({
            name: 'formPdf',
            params: {
                id: idFile,
            },
        });
        window.open(route.href);
    },
    // async openPdf(form) {
    //     let idFile = form.formType !== 'DOCUMENT' ? form.idForm : form.idFileSigned || form.idFile;
    //     printAsync(async () => {
    //         let blob = await GalleryCalls.getFileById(idFile);
    //         console.log(blob);
    //         return URL.createObjectURL(blob);
    //     });
    // },
    isIpad: () => {
        return !!navigator.platform && (navigator.platform === 'iPad' || navigator.platform === 'MacIntel');
    },
    isIOS: () => {
        return !!navigator.platform && /iPad|iPhone|iPod|Macintosh/.test(navigator.platform);
    },
    tokenObj: () => {
        return JSON.parse(localStorage.getItem('token'));
    },
    getAllFormsByLocation: (clientId) => {
        return new Promise((resolve, reject) => {
            FormsCalls.getAllFormsByLocation(clientId, JSON.parse(localStorage.getItem('token')))
                .then(({ data }) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    getPopulatedFormsByClientId: (clientId) => {
        return new Promise((resolve, reject) => {
            FormsCalls.getPopulatedForms(clientId, JSON.parse(localStorage.getItem('token')))
                .then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    stopBodyScrolling: (bool) => {
        if (bool === true) {
            document.body.addEventListener('touchmove', (e) => e.preventDefault(), false);
        } else {
            document.body.removeEventListener('touchmove', (e) => e.preventDefault(), false);
        }
    },
    getGuidEmailRegex: () => {
        return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}@iklient.cz$/;
    },
    checkSizeLessThan: (size) => {
        return store.state.windowWidth < size;
    },
    updateLocale(locale, isId = false) {
        //TODO: setLanguageToUser¨

        //If searching by code, wanna call the API
        if (!isId) {
            Helper.getAllLanguagesAsync().then((res) => {
                const lnObj = res.find((language) => language.code === locale);

                i18n.locale = lnObj.code.split('-')[0];
                store.dispatch('updateLanguage', lnObj);
            });
            //searching by ID, which means you aint no need to change
        } else {
            Helper.getAllLanguagesAsync().then((res) => {
                const lnObj = res.find((language) => language.idLanguage === locale);

                i18n.locale = lnObj.code.split('-')[0];
                //directly change Vuex
                store.commit('UPDATE_LANGUAGE', lnObj);
                //store.dispatch('updateLanguage', lnObj);
            });
        }
    },
    getLocaleCodeById: (id) => {
        let code;
        Helper.getAllLanguagesAsync().then((res) => {
            code = res.find((language) => language.idLanguage === id);
        });
        return code.code;
    },
    isEmail: (email) => {
        let result = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(email);
        return result;
    },
    isZipCode: (zipcode) => {
        let result = /^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$/i.test(zipcode);
        return result;
    },
    containsDia: (email) => {
        let result = /[À-ž]/i.test(email);
        return result;
    },
    calculateAspectRatioFit: (srcWidth, srcHeight, maxWidth, maxHeight) => {
        var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

        return {
            width: srcWidth * ratio,
            height: srcHeight * ratio,
        };
    },
    removeDiacritics: (str) => {
        const charsDiacs = 'ÁÄČÇĎÉĚËÍŇÓÖŘŠŤÚŮÜÝŽáäčçďéěëíňóöřšťúůüýž';
        const charsNorm = 'AACCDEEEINOORSTUUUYZaaccdeeeinoorstuuuyz';
        let strRes = '';
        for (let i = 0; i < str.length; i++) {
            if (charsDiacs.indexOf(str[i]) !== -1) {
                strRes += charsNorm[charsDiacs.indexOf(str[i])];
            } else {
                strRes += str[i];
            }
        }
        return strRes;
    },
    escapeHtml: (str) => {
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    },
    getFieldDefinition(key, formDefinition) {
        for (let i = 0; i < formDefinition.length; i++) {
            let field = formDefinition[i];
            if (this.fieldKey(field.key) === key) {
                return field;
            }
        }
    },
    fieldKey(key) {
        return Array.isArray(key) ? key[0] : key;
    },
    traverse(o, func) {
        for (var i in o) {
            func.apply(this, [i, o[i], o]);
            if (o[i] !== null && typeof o[i] == 'object') {
                this.traverse(o[i], func);
            }
        }
    },
    async sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    },
    select2component() {
        return {
            props: ['value', 'settings', 'disabled'],
            template: '<input type="text">',
            mounted() {
                if (this.settings.delay > 0) {
                    let query = this.settings.query;
                    let timer;
                    this.settings.query = (opt) => {
                        clearTimeout(timer);
                        timer = setTimeout(() => {
                            query(opt);
                        }, this.settings.delay);
                    };
                }

                $(this.$el).select2(this.settings);

                const events = ['change', 'selecting', 'selected', 'opening', 'open', 'close', 'highlight', 'clearing', 'removing', 'removed', 'loaded', 'focus', 'blur'].map((i) => 'select2-' + i);

                $(this.$el).on(events.join(' '), (e) => {
                    this.$emit(e.type.replace(/^select2-/, ''), e);
                });

                $(this.$el).on('change', (e) => {
                    this.$emit('input', this.method('data'));
                });

                this.method('data', this.value);
            },
            methods: {
                method(...args) {
                    return $(this.$el).select2(...args);
                },
                focus() {
                    this.method('focus');
                },
            },
            watch: {
                value(val, oldVal) {
                    this.method('data', val);
                },
                disabled() {
                    this.method('enable', !this.disabled);
                },
            },
            beforeDestroy() {
                this.method('destroy');
            },
        };
    },
};

export default helpers;
